import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @record.comment}}\n  {{format-nl2br @record.comment}}\n{{/if}}")